module.exports = __webpack_public_path__ + "static/scale-model-of-superelectric-pinball-parlor-in-cleveland-ohio-eaef6042247abf6d554fe6f2a16eaac4.png";